var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVelvMinimized(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 390,
    height: 360,
    viewBox: "0 0 390 360",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gruppo"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Percorso",
    fill: "#009cff",
    stroke: "none",
    d: "M 246.762283 228.765289 L 135.3927 282.233704 C 130.643097 284.5401 125.667 285.626404 120.736496 285.626404 C 108.070496 285.626404 95.947502 278.524506 90.1119 266.355896 C 82.0149 249.483307 89.116798 229.217697 106.035004 221.075409 L 139.0401 205.231201 C 157.608292 196.317612 179.220001 196.320313 197.785492 205.238419 L 246.762283 228.765289 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1",
    fill: "none",
    stroke: "#15e0ff",
    strokeWidth: 67.853104,
    strokeLinecap: "round",
    d: "M 120.701698 105.505508 L 272.859894 178.587006"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVelvMinimized);
export default __webpack_public_path__ + "static/media/velv-minimized.5218fb6dbd136ca10213361a418a2e34.svg";
export { ForwardRef as ReactComponent };